/* ATPRO: Predictive Search SKU support (Flex / PXUTheme)
   - Adds variants.sku to Predictive Search fields so partial SKU searches return products
   - Update-safe: overrides only getResults at runtime (no core file edits)
*/
(function () {
  function patch() {
    if (!window.PXUTheme || !window.PXUTheme.predictiveSearch || window.PXUTheme.predictiveSearch.__atproSkuPatched) {
      return false;
    }
    if (!window.PXUTheme.predictiveSearch.getResults || !window.PXUTheme.routes || !window.PXUTheme.routes.predictive_search_url) {
      return false;
    }

    window.PXUTheme.predictiveSearch.__atproSkuPatched = true;

    // Override ONLY getResults to add SKU field support
    window.PXUTheme.predictiveSearch.getResults = function (term, $this) {
      const { header_layout } = window.PXUTheme.theme_settings;

      if (term.length === 0) {
        if (header_layout === 'vertical' || header_layout === 'search_focus') {
          window.PXUTheme.predictiveSearch.unlockBodyScroll();
        }
        window.PXUTheme.predictiveSearch.clearResults();
        return;
      }

      const { searchResourceType } = window.PXUTheme.predictiveSearch.vars;
      const restrictResourceCondition = searchResourceType && 'searchResourceType' in $this[0].dataset;

      // IMPORTANT: include variants.sku so SKU searches work
      const fields = 'title,product_type,variants.title,vendor,variants.sku';

      const url =
        `${window.PXUTheme.routes.predictive_search_url}` +
        `?q=${encodeURIComponent(term)}` +
        `&section_id=predictive-search` +
        `&resources[options][fields]=${encodeURIComponent(fields)}` +
        (restrictResourceCondition ? `&resources[type]=${encodeURIComponent(searchResourceType)}` : '');

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          window.PXUTheme.predictiveSearch.displayResults(text, $this);

          // Keep Flex behavior for vertical/search_focus overlays
          if ((header_layout === 'vertical' || header_layout === 'search_focus') && $this.closest('.jsHeader').length > 0) {
            window.PXUTheme.predictiveSearch.lockBodyScroll();
          }
        })
        .catch((error) => {
          throw error;
        });
    };

    return true;
  }

  // Try to patch after theme loads; retry briefly if load order is delayed
  function boot() {
    if (patch()) return;
    let tries = 0;
    const timer = setInterval(function () {
      tries += 1;
      if (patch() || tries > 100) clearInterval(timer); // ~5s max
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();